import { render, staticRenderFns } from "./TasasApp.vue?vue&type=template&id=766f02ea&scoped=true&lang=pug"
import script from "./TasasApp.vue?vue&type=script&lang=js"
export * from "./TasasApp.vue?vue&type=script&lang=js"
import style0 from "./TasasApp.vue?vue&type=style&index=0&id=766f02ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f02ea",
  null
  
)

export default component.exports